import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { Button, TextField, CircularProgress } from "@mui/material";
import "./DocumentSetting.css";
import { createDocumentsCategory } from "../../api/axios";

function AddCategoryModal(props) {
  const {
    handleBack,
    allOptions,
    setAllOptions,
    partnerId,
    setShowModal
  } = props;

  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleCloseModal = () => {
    handleBack();
    setShowModal(false);
  };

  const handleSave = async () => {
    if (!categoryName.trim()) {
      setError("Category name is required");
      return;
    }

    setLoading(true);
    try {
      const dataToSend = {
        partner_id: partnerId,
        name: categoryName,
      };

      const response = await createDocumentsCategory(dataToSend);
      
      if (response?.data?.data?.id) {
        const newOption = {
          value: response?.data?.data?.id,
          label: response?.data?.data.name,
        };
        setAllOptions((prevOptions) => [...prevOptions, newOption]);
        handleCloseModal();
      } else {
        setError("Something went wrong! Please try again later.");
      }
    } catch (error) {
      console.error("Error creating category:", error);
      setError(error?.response?.data?.message || "Something went wrong! Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="category-modal-container">
      <div
        className="modal-backdrop"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 100,
        }}
        onClick={handleCloseModal}
      ></div>
      <div
        className="modal-content"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          padding: "24px",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
          zIndex: 101,
          width: "90%",
          maxWidth: "500px",
        }}
      >
        <h2 style={{ marginBottom: "20px", fontSize: "20px", fontWeight: "500" }}>
          Add New Category
        </h2>
        
        <div style={{ marginBottom: "20px" }}>
          <TextField
            label="Category Name"
            variant="outlined"
            fullWidth
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            error={!!error}
            helperText={error}
            placeholder="Enter category name"
            autoFocus
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: error ? '#d32f2f' : '#e0e0e0',
                },
                '&:hover fieldset': {
                  borderColor: error ? '#d32f2f' : '#47b0e2',
                },
                '&.Mui-focused fieldset': {
                  borderColor: error ? '#d32f2f' : '#47b0e2',
                },
              },
            }}
          />
        </div>
        
        <div style={{ display: "flex", gap: "10px" }}>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={loading}
            style={{
              flex: 1,
              backgroundColor: "#47b0e2",
              color: "white",
              textTransform: "none",
              padding: "8px 16px",
              fontSize: "14px",
            }}
          >
            {loading ? (
              <CircularProgress size={24} style={{ color: "white" }} />
            ) : (
              "Submit"
            )}
          </Button>
          
          <Button
            variant="outlined"
            onClick={handleCloseModal}
            disabled={loading}
            style={{
              flex: 1,
              borderColor: "#47b0e2",
              color: "#47b0e2",
              textTransform: "none",
              padding: "8px 16px",
              fontSize: "14px",
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AddCategoryModal; 